import { Navigate, Route, Routes } from "react-router-dom";
import { NotFound, NotAuthorized, Callback } from "../pages";

import { Dashboard, DashboardV2, Login, CalendarV2, Logout } from "../components";
import { PostAuthentication, GeneralWrapper } from "../layout";
import { ProtectedRoute } from ".";

import projectRoutes from "../components/Project/routes";
import adminRoutes from "../components/Administration/routes";
import listRoutes from "../components/Reports/routes";
import inventoryRoutes from "../components/Inventory/routes";
import supplierRoutes from "../components/Supplier/routes";

export default function RootRoute() {
    return (
        <Routes>
            <Route path="/auth/landing" element={<Login />} />
            <Route path="/auth/callback" element={<Callback />} />
            <Route path="/auth/logout/callback" element={<Logout />} />
            <Route path="/unauthorized" element={<NotAuthorized />} />

            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <PostAuthentication />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Navigate to="dashboard" replace />} />,
                <Route path="dashboard" element={<DashboardV2 />} />
                <Route path="calendar" element={<CalendarV2 />} />
                <Route path="calendar" element={<CalendarV2 />} />
                <Route path="project" element={<GeneralWrapper />}>
                    {projectRoutes}
                </Route>
                <Route path="inventory" element={<GeneralWrapper />}>
                    {inventoryRoutes}
                </Route>
                <Route path="suppliers" element={<GeneralWrapper />}>
                    {supplierRoutes}
                </Route>
                <Route path="reports" element={<GeneralWrapper />}>
                    {listRoutes}
                </Route>
                <Route path="admin" element={<GeneralWrapper />}>
                    {adminRoutes}
                </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
